__turbopack_context__.v({
  "active": "Tab-module__LGq3Hq__active",
  "tab": "Tab-module__LGq3Hq__tab",
});
